<script lang="ts">
  import { onMount } from "svelte";
  import { CyberWorld } from "../three/CyberWorld.ts";
  import { settings } from "../stores/settings.svelte.ts";

  let canvas: HTMLCanvasElement;
  let world: CyberWorld | null = null;

  onMount(() => {
    world = new CyberWorld(canvas);
    if (import.meta.env.DEV) (window as unknown as { __cyber?: CyberWorld }).__cyber = world; // dev console hook
    world.start();
    const onResize = () => world?.resize();
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      world?.dispose();
      world = null;
    };
  });

  // Quality tier (manual or the auto perf monitor) / reduced-effects change → drop the ambient loop to
  // a static frame on Low, or spin it back up. Stops the fullscreen shader heating a weak machine on menus.
  $effect(() => {
    settings.renderQuality;
    settings.autoTier;
    settings.reducedEffects;
    world?.refreshMotion();
  });
</script>

<!-- Vignette/grain/scanlines are graded inside the shader (see CyberWorld.ts). -->
<div class="fixed inset-0 -z-10" style="background:var(--color-void)">
  <canvas bind:this={canvas} class="block h-full w-full"></canvas>
</div>
